<template>
  <ExamStart :path="'/byl'"></ExamStart>
</template>

<script>
  import ExamStart from '@/page/modules/exam/start'
  export default {
    components: { ExamStart },
    mounted () {
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/byl/exam/start.vue